/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import classnames from 'classnames';
import * as React from 'react';

export interface IRadioButtonProps {
    isChecked?: boolean;
    value?: string;
    ariaSetSize?: number;
    ariaPosInSet?: number;
    ariaLabel?: string;
    name: string;
    className?: string;
    isSingleSelectOnly?: boolean;
    onChange(reacords: object): void;
}

/**
 * AddPaymentForm SFC.
 * @param root0
 * @param root0.isChecked
 * @param root0.value
 * @param root0.ariaLabel
 * @param root0.name
 * @param root0.className
 * @param root0.onChange
 * @param root0.isSingleSelectOnly
 * @extends {React.FC<IRadioButtonProps>}
 */
const CheckBoxButton: React.FC<IRadioButtonProps> = ({ isChecked, value, ariaLabel, name, className, onChange, isSingleSelectOnly }) => {
    const cssClass = classnames('ms-input-radio', className ? className : '');
    return (
        <input
            className={cssClass}
            checked={isChecked}
            aria-checked={isChecked}
            type={isSingleSelectOnly ? 'radio' : 'checkbox'}
            aria-label={ariaLabel}
            value={value}
            name={name}
            onChange={onChange}
        />
    );
};

export default CheckBoxButton;
